<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0_1_5)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6585 0.247423C10.2813 -0.0826584 9.71793 -0.0824515 9.34094 0.247907L1.35278 7.24791C1.1361 7.43779 1.01184 7.71189 1.01184 8V17.3215C1.01184 18.0287 1.29279 18.707 1.79289 19.2071C2.29299 19.7072 2.97126 19.9882 3.67851 19.9882H16.3452C17.0524 19.9882 17.7307 19.7072 18.2308 19.2071C18.7309 18.707 19.0118 18.0287 19.0118 17.3215V17.3202L19 7.99873C18.9996 7.71081 18.8752 7.43702 18.6585 7.24742L10.6585 0.247423ZM3.01184 8.45333L10.0005 2.3292L17.0006 8.45427L17.0118 17.3215C17.0117 17.4981 16.9415 17.668 16.8166 17.7929C16.6916 17.9179 16.522 17.9882 16.3452 17.9882H14V11C14 10.4477 13.5523 10 13 10H7C6.44772 10 6 10.4477 6 11V17.9882H3.67851C3.5017 17.9882 3.33213 17.9179 3.2071 17.7929C3.08208 17.6679 3.01184 17.4983 3.01184 17.3215V8.45333ZM8 17.9882H12V12H8V17.9882Z" fill="#858E97"/>
        </g>
        <defs>
            <clipPath id="clip0_1_5">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconPurchase',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
